import { AlertOutlined, CalendarOutlined, CameraOutlined, HomeOutlined, UserOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Card, Col, Row, Spin, Statistic, Table, Tag, Typography } from "antd";
import { useAuthStore } from "@/modules/auth/store/auth.store";
import { statsService } from "../services/stats.service";

const { Title, Text } = Typography;

export function DashboardPage() {
	const user = useAuthStore((state) => state.user);

	const { data, isLoading } = useQuery({
		queryKey: ["stats", "dashboard"],
		queryFn: () => statsService.dashboard(),
		refetchInterval: 30000,
	});

	const stats = data?.data;

	if (isLoading) return <Spin size="large" className="flex justify-center mt-20" />;

	return (
		<div>
			<div className="mb-6">
				<Title level={3} className="!mb-1">Dashboard</Title>
				<Text type="secondary">Xush kelibsiz, {user?.name}! Rol: {user?.role?.name}</Text>
			</div>

			<Row gutter={[16, 16]} className="mb-6">
				<Col xs={24} sm={12} lg={6}>
					<Card><Statistic title="Bugungi tadbirlar" value={stats?.events_summary?.total_events || 0} prefix={<CalendarOutlined />} /></Card>
				</Col>
				<Col xs={24} sm={12} lg={6}>
					<Card>
						<Statistic title="Hozirda faol" value={stats?.events_summary?.active_now || 0} prefix={<AlertOutlined />}
							valueStyle={{ color: stats?.events_summary?.active_now > 0 ? "#cf1322" : undefined }} />
					</Card>
				</Col>
				<Col xs={24} sm={12} lg={6}>
					<Card>
						<Statistic title="NVR (online/jami)" value={stats?.devices?.nvrs_online || 0}
							suffix={`/ ${stats?.devices?.total_nvrs || 0}`} prefix={<VideoCameraOutlined />} />
					</Card>
				</Col>
				<Col xs={24} sm={12} lg={6}>
					<Card><Statistic title="To'yxonalar" value={stats?.halls?.total || 0} prefix={<HomeOutlined />} /></Card>
				</Col>
			</Row>

			<Row gutter={[16, 16]} className="mb-6">
				<Col xs={24} sm={12} lg={6}>
					<Card><Statistic title="Kameralar" value={stats?.devices?.total_cameras || 0} prefix={<CameraOutlined />} /></Card>
				</Col>
				<Col xs={24} sm={12} lg={6}>
					<Card><Statistic title="Sanatkorlar" value={stats?.artists?.total || 0} prefix={<UserOutlined />} /></Card>
				</Col>
				<Col xs={24} sm={12} lg={6}>
					<Card>
						<Statistic title="Offline NVR" value={stats?.devices?.nvrs_offline || 0}
							valueStyle={{ color: stats?.devices?.nvrs_offline > 0 ? "#cf1322" : "#3f8600" }} />
					</Card>
				</Col>
			</Row>

			{stats?.alerts?.length > 0 && (
				<Card title="Ogohlantirishlar" className="mb-6" styles={{ header: { background: "#fff2f0" } }}>
					{stats.alerts.map((alert: { type: string; message: string; severity: string }, i: number) => (
						<div key={i} className="flex items-center gap-2 mb-2">
							<Tag color={alert.severity === "critical" ? "red" : "orange"}>{alert.type}</Tag>
							<Text>{alert.message}</Text>
						</div>
					))}
				</Card>
			)}

			<Card title="So'nggi tadbirlar">
				<Table dataSource={stats?.recent_events || []} rowKey="id" pagination={false} size="small"
					columns={[
						{ title: "ID", dataIndex: "id", width: 60 },
						{ title: "To'yxona", dataIndex: "wedding_hall_name" },
						{ title: "Turi", dataIndex: "event_type", render: (v: string) => <Tag color={v === "wedding" ? "red" : v === "celebration" ? "green" : "blue"}>{v}</Tag> },
						{ title: "Pik odam", dataIndex: "peak_count" },
						{ title: "Vaqt", dataIndex: "started_at" },
					]} />
			</Card>
		</div>
	);
}
